import { CardContainer, PhoneNumbersForm } from '@/_containers';

export function ProfileRightSection({ isEditable }: { isEditable: boolean }) {
  return (
    <>
      <CardContainer right>
        <PhoneNumbersForm isEditable={isEditable} isSortable />
      </CardContainer>
    </>
  );
}
